import { Component, Inject, EventEmitter, Output } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';
import { AbilityService } from '../../../_shared/services/ability.service';
import { UtilService } from '../../../_shared/services/util.service';

import { LanguageService } from '../../../languages/shared/language.service';

import { PickupPlace } from '../../shared/pickup-place.model';
import { PickupPlaceService } from '../../shared/pickup-place.service';
import { PickupPlaceListComponent } from '../../pickup-place-list/pickup-place-list.component';
import { PickupPlaceDetailComponent } from '../../pickup-place-detail/pickup-place-detail.component';

@Component({
  selector: 'app-pickup-places-modal',
  templateUrl: './pickup-places-modal.component.html',
  standalone: true,
  imports: [SharedModule, PickupPlaceListComponent, PickupPlaceDetailComponent],
})
export class PickupPlacesModalComponent {
  // @Output() private dialogSaved = new EventEmitter<any>(); // avoid closing the dialog

  modalTitle = this.data.title;
  // lang = this.data.params.lang;

  pickupPlaces: PickupPlace[];
  meta = [];
  pickupPlace: PickupPlace;
  mode = '';
  loadingPickupPlaces = false;

  listMode = true;
  detailMode = false;

  permissions = {
    canList: this.abilityService.can('index_pickupplace_accountadmin'),
    canCreate: this.abilityService.can('create_pickupplace_accountadmin'),
  };

  defaultLanguage: any;

  private filterCriteria = this.pickupPlaceService.getFilterCriteria();
  additionalLanguages = [];

  constructor(
    private pickupPlaceService: PickupPlaceService,
    private languageService: LanguageService,
    private abilityService: AbilityService,
    private utilService: UtilService,
    private ref: MatDialogRef<PickupPlacesModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    // use it onInit ??
    this.getAdditionalLanguages();
  }

  showPickupPlaces() {
    this.listMode = true;
    this.detailMode = false;

    this.getPickupPlaces();
  }

  addPickupPlace() {
    this.modalTitle = 'ADD_PICKUP_PLACE';
    this.listMode = false;
    this.detailMode = true;

    this.pickupPlace = { name: '' };
  }

  // Referenced from app-pickupPlace-detail
  onSavedPickupPlace(pickupPlace) {
    this.pickupPlace = pickupPlace;

    this.listMode = true;
    this.detailMode = false;

    this.getPickupPlaces(pickupPlace);

    // this.ref.close(pickupPlace); // close the dialog
  }

  // Referenced from app-pickupPlace-detail
  onCanceledPickupPlace() {
    this.showPickupPlaces();
  }

  close() {
    // this.private .emit(true); // avoid closing the dialog
    this.ref.close(true); // close the dialog
  }

  // Referenced from app-pickupPlace-list
  onSelectedPickupPlace({ pickupPlace, mode = '' }) {
    // this.pickupPlace = pickupPlace;
    this.mode = mode;

    this.modalTitle = 'PICKUP_PLACE_DETAILS';
    this.listMode = false;
    this.detailMode = true;

    this.getPickupPlace(pickupPlace.id);
  }

  private getPickupPlaces(selectedPickupPlace = null) {
    this.filterCriteria.lang = this.defaultLanguage.lang;

    this.loadingPickupPlaces = true;
    this.pickupPlaceService.getPickupPlaces(this.filterCriteria).subscribe((response) => {
      this.pickupPlaces = response.data;
      this.meta = response.meta;

      this.loadingPickupPlaces = false;

      if (selectedPickupPlace) {
        this.utilService.changeItemRowStyle(selectedPickupPlace.id);
      }
    });
  }

  private getPickupPlace(pickupPlaceId) {
    this.pickupPlace = null;

    this.pickupPlaceService.getPickupPlace(pickupPlaceId).subscribe((response) => {
      this.pickupPlace = response;
    });
  }

  private getAdditionalLanguages() {
    this.languageService.getLanguages({ skip_check_role: true }).subscribe((response) => {
      this.defaultLanguage = response.data.find((language) => language.is_default);
      this.additionalLanguages = response.data.filter((language) => !language.is_default);

      this.getPickupPlaces();
    });
  }
}
